import { render, staticRenderFns } from "./modal-generic.vue?vue&type=template&id=10a08b22&"
import script from "./modal-generic.vue?vue&type=script&lang=js&"
export * from "./modal-generic.vue?vue&type=script&lang=js&"
import style0 from "./modal-generic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports